/**
 * @param {Array} groups
 *
 * @return {Object}
 */
export const buildValuesFromGroups = groups => {
  let values = {};

  Object.keys(groups).forEach(title => {
    const { [title]: group = [] } = groups;
    values = {
      ...values,
      ...buildValuesFromGroup(group),
    };
  });

  return values;
};

/**
 * Convert an array of AccessRoleItems
 * into an object for the Redux Form
 *
 * @param {Array} group
 *
 * @return {Object}
 */
export const buildValuesFromGroup = group => {
  let values = {};

  group.forEach(item => {
    const Id = accessRowToFieldId(item);
    if (item.AllowRead) {
      values[`AllowRead${Id}`] = true;
    } else {
      values[`AllowRead${Id}`] = false;
    }

    if (item.AllowWrite) {
      values[`AllowWrite${Id}`] = true;
    } else {
      values[`AllowWrite${Id}`] = false;
    }
  });

  return values;
};

/**
 * @param {Array} group
 */
export const groupDisplayReadOnly = (group = []) =>
  !!group.filter(item => item.IsViewOnlyApplicable).length;

/**
 * @param {Array} group
 */
export const groupDisplayPreferences = (group = []) =>
  !!group.filter(
    item => item.Preferences !== undefined && item.Preferences.length
  ).length;

export const accessRowToFieldId = row => {
  return `${row.ProductId}-${row.Id}`;
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/form.js